<template>
  <div>
    <AllOrders :samplePending="true"></AllOrders>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const AllOrders = defineAsyncComponent(() =>
  import("@/components/orders/AllOrders")
);
export default {
  components: {
    AllOrders,
  },
};
</script>
